import { Page, Header, Content } from '@backstage/core-components';
import { CatalogTable, CatalogTableColumnsFunc } from '@backstage/plugin-catalog';
import {
  CatalogFilterLayout,
  DefaultFilters,
  EntityListProvider,
} from '@backstage/plugin-catalog-react';

const KUBERNETES_VERSION_LABEL = 'eks/kubernetes-version';

const catalogColumns: CatalogTableColumnsFunc = entityListContext => {
  const defaultColumns = CatalogTable.defaultColumnsFunc(entityListContext);
  const hasKubernetesVersion = entityListContext.entities.some(entity =>
    Boolean(entity.metadata.labels?.[KUBERNETES_VERSION_LABEL]),
  );

  if (!hasKubernetesVersion) {
    return defaultColumns;
  }

  const kubernetesVersionColumn = {
    ...CatalogTable.columns.createLabelColumn(KUBERNETES_VERSION_LABEL, {
      title: 'Kubernetes Version',
    }),
    defaultSort: 'asc' as const,
  };

  return [...defaultColumns, kubernetesVersionColumn];
};

/**
 * CatalogPage
 *
 * Custom catalog page with default namespace filters.
 */
const CatalogPage = () => (
  <Page themeId="home">
    <Header title="Catalog" />
    <Content>
      <EntityListProvider>
        <CatalogFilterLayout>
          <CatalogFilterLayout.Filters>
            <DefaultFilters
              initiallySelectedNamespaces={[
                'default',
                'technology',
                'eks-platform',
              ]}
            />
          </CatalogFilterLayout.Filters>
          <CatalogFilterLayout.Content>
            <CatalogTable
              columns={catalogColumns}
              tableOptions={{ thirdSortClick: false }}
            />
          </CatalogFilterLayout.Content>
        </CatalogFilterLayout>
      </EntityListProvider>
    </Content>
  </Page>
);

export default CatalogPage;
